import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import {
  FETCH_GTM_PROJECT_TASKS,
  FETCH_PROJECT_TASKS,
} from "../projects/graphql";

const ProjectTasksView = ({ projectType, projectId }) => {
  const query =
    projectType === "GTM" ? FETCH_GTM_PROJECT_TASKS : FETCH_PROJECT_TASKS;
  const { loading, error, data } = useQuery(query, {
    variables: { id: projectId },
    pollInterval: process.env.NODE_ENV === "production" ? 5000 : 100000,
  });

  if (loading) return <div>Loading Tasks...</div>;
  if (error) return <Errors error={error} />;

  const workingTasks = data.project.tasks
    .filter((i) => !i.completedAt)
    .sort((a, b) => a.ordering - b.ordering);

  return (
    <div>
      <div>
        <label>Current Tasks</label>
      </div>
      {workingTasks.length === 0 && (
        <div className="opacity-70 mt-2">No tasks at the moment.</div>
      )}

      {workingTasks.length > 0 && (
        <div className="-mx-2 mt-2">
          <table>
            <tbody>
              {workingTasks.map((i) => (
                <tr
                  className="border-y border-gray-100 dark:border-gray-700"
                  key={i.id}
                >
                  <td>- {i.name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ProjectTasksView;
